<template>
  <div>
    <div class="section">
      <div class="post">
        <span>申请本协会</span>
        <apply-name tag="h5"/>
      </div>
      <div class="money">
        <span>缴费金额：</span>
        <pay-fee-amount/>
      </div>
      <div class="money">
        <span>支付方式</span>
        <div class="clearfix pay">
          <i></i>
          <span>微信支付</span>
        </div>
      </div>

      <invoice :invoice-info="invoiceInfo" ref="invoiceForm"/>
    </div>
    <button class="btn-main btn-submit" @click="onlinePay">确定支付</button>
    <footer-logo/>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
import VDistpicker from '@/components/distpicker.vue'
import ApplyName from '@/components/member/ApplyName.vue'
import FeeAmount from '@/components/member/FeeAmount.vue'
import Invoice from '@/components/member/Invoice.vue'
import PayFeeAmount from '@/components/member/PayFeeAmount.vue'
export default {
  components: {
    'footer-logo': footerLogo,
    VDistpicker,
    ApplyName,
    FeeAmount,
    PayFeeAmount,
    Invoice
  },
  data() {
    return {
      invoiceType: 1,
      invoiceInfo: {},
      applyname: '',
      paymentData: {
        orderMoney: this.$route.query.amount,
        tradeNo: ''
      }
    }
  },
  created() {},
  methods: {
    pay(orderNo) {
      var url =
        this.apiBaseUrl +
        '/api/OrganizationEnterprise/CreatePayOrder?orderNo=' +
        orderNo +
        '&isPC=false'
      window.location.href = url
    },
    onlinePay() {
      if (!this.$refs.invoiceForm.check()) {
        return
      }
      var postData = {
        isRequired: this.invoiceInfo.isRequired,
        name: this.invoiceInfo.Name,
        title: this.invoiceInfo.Title,
        taxNumber: this.invoiceInfo.TaxNum,
        address: this.invoiceInfo.Address,
        Telephone: this.invoiceInfo.Telephone
      }

      this.$post('/api/OrganizationEnterprise/SubmitOnlinePay', postData)
        .then(result => {
          var orderNo = result
          this.pay(orderNo)
        })
        .catch(result => {
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 1500
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.section {
  width: 100%;
  height: auto;
  background: #fff;
  padding-bottom: 20 / @rem-size;

  .label {
    width: 100%;
    padding: 25 / @rem-size 24 / @rem-size 0;

    .label-title {
      font-size: 28 / @rem-size;
      color: #333;
    }

    .money {
      color: #ff3939;
      font-size: 28 / @rem-size;
      margin-top: 15 / @rem-size;

      span {
        display: inline;
        padding: 0;
      }
    }
  }
}

.foot-hint {
  font-size: 24 / @rem-size;
  color: #999;
  padding: 30 / @rem-size 24 / @rem-size 0;
  line-height: 35 / @rem-size;

  span {
    color: #0563d8;
  }
}

.btn-submit {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: auto;
  margin-top: 35 / @rem-size;
  border-radius: 8 / @rem-size;
  font-size: 36 / @rem-size;
}

.section {
  .post,
  .money {
    span {
      display: block;
      font-size: 28 / @rem-size;
      padding: 30 / @rem-size 24 / @rem-size 0;
      color: #999;
    }

    h5 {
      color: #333;
      font-size: 36 / @rem-size;
      padding: 0 24 / @rem-size;
      line-height: 88 / @rem-size;
      font-weight: normal;
    }

    h4 {
      color: #ff3939;
      font-size: 48 / @rem-size;
      padding: 0 24 / @rem-size;
      line-height: 88 / @rem-size;
      font-weight: normal;

      span {
        display: inline;
        padding: 0;
        color: #ff3939;
      }
    }
  }

  .money {
    span {
      padding-top: 5 / @rem-size;
    }
  }

  .pay {
    padding: 0 24 / @rem-size;
    margin-top: 15 / @rem-size;

    i {
      display: block;
      width: 50 / @rem-size;
      height: 50 / @rem-size;
      background-image: url('../../assets/images/wx-pay.png');
      background-size: 100% 100%;
      float: left;
    }

    span {
      float: left;
      line-height: 50 / @rem-size;
      color: #333;
      padding-top: 0;
    }
  }
}

.mat-30 {
  margin-top: 30 / @rem-size;
}
</style>
